__turbopack_context__.v({
  "capabilitiesSection": "AiInRecruitingCapabilitiesSection-module__Y0FRTa__capabilitiesSection",
  "header": "AiInRecruitingCapabilitiesSection-module__Y0FRTa__header",
  "itemDesc": "AiInRecruitingCapabilitiesSection-module__Y0FRTa__itemDesc",
  "itemTitle": "AiInRecruitingCapabilitiesSection-module__Y0FRTa__itemTitle",
  "number": "AiInRecruitingCapabilitiesSection-module__Y0FRTa__number",
  "row": "AiInRecruitingCapabilitiesSection-module__Y0FRTa__row",
  "rowActive": "AiInRecruitingCapabilitiesSection-module__Y0FRTa__rowActive",
  "sectionSubtitle": "AiInRecruitingCapabilitiesSection-module__Y0FRTa__sectionSubtitle",
  "sectionTitle": "AiInRecruitingCapabilitiesSection-module__Y0FRTa__sectionTitle",
});
